import 'jquery';
import Swiper, { Autoplay, Navigation, Keyboard, Pagination } from 'swiper';
import AOS from 'aos';

Swiper.use([Autoplay, Navigation, Keyboard, Pagination]);

const navigation = (el) => {
  const swiperClass = {
    nextEl: '.' + el + '-swiper__button--next',
    prevEl: '.' + el + '-swiper__button--prev',
  };
  return swiperClass;
};

let swiper;

$(window).on('load', function () {
  if ($('.objects__swiper').length) {
    swiper = new Swiper('.objects__swiper', {
      loop: false,
      slidesPerView: 1,
      spaceBetween: 35,
      navigation: navigation('objects__swiper'),
      breakpoints: {
        992: {
          slidesPerView: 3,
        },
        768: {
          slidesPerView: 2,
        },
        0: {
          slidesPerView: 1,
        },
      },
    });
  }
  if ($('.rw-media__swiper').length) {
    swiper = new Swiper('.rw-media__swiper', {
      loop: false,
      slidesPerView: 'auto',
      spaceBetween: 0,
      navigation: navigation('rw-media__swiper'),
      // on : {
      //     afterInit: function () {
      //         var right = $(window).width() - ($('.rw-media__swiper .swiper-slide-active').offset().left + $('.rw-media__swiper .swiper-slide-active').width());
      //         $('.rw-media__swiper .rw-media__swiper__layer').css('width', right);
      //     },
      // }
      // breakpoints: {
      //     768: {
      //         slidesPerView: 'auto',
      //     },
      //     0: {
      //         slidesPerView: 1.08,
      //     },
      // },
    });
  }
  if ($('.slider__swiper--small').length) {
    swiper = new Swiper('.slider__swiper--small', {
      loop: false,
      slidesPerView: 1.1,
      spaceBetween: 0,
      breakpoints: {
        768: {
          slidesPerView: 'auto',
          spaceBetween: 30,
        },
        0: {
          slidesPerView: 1.1,
          spaceBetween: 0,
        },
      },
    });
  }
  if ($('.slider__swiper--big').length) {
    swiper = new Swiper('.slider__swiper--big', {
      loop: false,
      slidesPerView: 1.1,
      navigation: navigation('slider-swiper--big'),
      spaceBetween: 0,
      breakpoints: {
        992: {
          slidesPerView: 1.3,
        },
        0: {
          slidesPerView: 1.1,
        },
      },
    });
  }
  if ($('.text-slider__swiper').length) {
    swiper = new Swiper('.text-slider__swiper', {
      loop: false,
      slidesPerView: 1,
      navigation: navigation('text-slider-swiper'),
      spaceBetween: 30,
    });
  }
  if ($('.recensies__content__items').length) {
    swiper = new Swiper('.recensies__content__items', {
      loop: false,
      slidesPerView: 1,
      navigation: navigation('recensie-swiper'),
      spaceBetween: 30,
      on: {
        afterInit: function () {
          $('.recensies__wrapper__image').html(
            $(
              '.recensies__content__items .swiper-slide-active .recensies__content__items__title__thumb'
            ).html()
          );
        },
        slideChangeTransitionStart: function () {
          $('.recensies__wrapper__image').css('opacity', 0);
        },
        slideChangeTransitionEnd: function () {
          $('.recensies__wrapper__image')
            .html(
              $(
                '.recensies__content__items .swiper-slide-active .recensies__content__items__title__thumb'
              ).html()
            )
            .css('opacity', 1);
          if (
            $('.recensie-swiper-swiper__button--next').hasClass(
              'swiper-button-disabled'
            )
          ) {
            $('.recensie-swiper-swiper__button--prev').addClass(
              'next-disabled'
            );
          } else {
            $('.recensie-swiper-swiper__button--prev').removeClass(
              'next-disabled'
            );
          }
        },
      },
    });
  }
  if ($('.related-swiper').length) {
    swiper = new Swiper('.related-swiper', {
      loop: false,
      slidesPerView: 1.1,
      navigation: navigation('related-swiper'),
      keyboard: {
        enabled: true,
      },
      spaceBetween: 15,
      breakpoints: {
        1200: {
          slidesPerView: 2.135,
          spaceBetween: 30,
        },
        992: {
          slidesPerView: 2.115,
          spaceBetween: 30,
        },
        0: {
          slidesPerView: 1.1,
          spaceBetween: 15,
        },
      },
    });
  }
  if ($('.image-swiper').length) {
    swiper = new Swiper('.image-swiper', {
      loop: true,
      slidesPerView: 1,
      navigation: navigation('image-swiper'),
      keyboard: {
        enabled: true,
        onlyInViewport: false,
      },
      pagination: {
        el: '.image-swiper .swiper-progress',
        type: 'fraction',
        formatFractionCurrent: function (number) {
          return ('0' + number).slice(-2);
        },
        formatFractionTotal: function (number) {
          return ('0' + number).slice(-2);
        },
      },
      // autoplay: {
      //     delay: 5000,
      // },
    });
  }
  if ($('.floorplan-swiper').length) {
    swiper = new Swiper('.floorplan-swiper', {
      loop: true,
      slidesPerView: 1,
      navigation: navigation('floorplan-swiper'),
      keyboard: {
        enabled: true,
        onlyInViewport: false,
      },
      pagination: {
        el: '.floorplan-swiper .swiper-progress',
        type: 'fraction',
        formatFractionCurrent: function (number) {
          return ('0' + number).slice(-2);
        },
        formatFractionTotal: function (number) {
          return ('0' + number).slice(-2);
        },
      },
      // autoplay: {
      //     delay: 5000,
      // },
    });
  }
  AOS.init({
    once: true,
    offset: 100,
  });
});

$(window).on('resize', function () {
  if (swiper) {
    swiper.update();
    AOS.refresh();
  }
});
